import React from 'react';
import styled from 'styled-components';
import { deriveSplitDataFromNamedKeyValue } from '../../domain';
import { AccountInfoResult } from '@block-explorer/entities';
import DetailsTableRow from '../details-table-row/details-table-row';
import DetailsNameTableData from '../details-name-table-data/details-name-table-data';
import { Trans, useTranslation } from 'react-i18next';
import DetailsValueTableData from '../details-value-table-data/details-value-table-data';
import { FlexRow, HashLength } from '@make-software/cspr-ui';
import { BodyText } from '@block-explorer/ui';
import { TableDataAccountInfo } from '../table-data-account-info/table-data-account-info';
import { deriveAccountInfo } from '../../utils/account.tsx';

export const TokenWrapper = styled.div(({ theme }) => ({
  padding: '4px 8px',
  borderRadius: '4px',
  backgroundColor: theme.styleguideColors.fillSecondary,
}));

interface DetailsAccordionAssociatedKeysItemProps {
  data: { account_hash: string; weight: number };
  index: number;
  loading: boolean;
  getAccountInfo: (publicKey: string) => AccountInfoResult | undefined;
}

export const DetailsAccordionAssociatedKeysItem = ({
  data,
  index,
  loading,
  getAccountInfo,
}: DetailsAccordionAssociatedKeysItemProps) => {
  const { t } = useTranslation();
  const { hash: hashWithoutPrefix } = deriveSplitDataFromNamedKeyValue(
    data.account_hash
  );
  const accountInfo = getAccountInfo(hashWithoutPrefix);
  const publicKey = accountInfo?.public_key;

  const accountInfoDetails = deriveAccountInfo(
    accountInfo?.account_info || accountInfo?.centralized_account_info
  );
  const logo = accountInfoDetails?.logo || null;
  const name = accountInfoDetails?.name;
  const csprName = accountInfo?.cspr_name;

  return (
    <DetailsTableRow>
      <DetailsNameTableData>
        <Trans t={t}>Key </Trans>
        {index + 1}
      </DetailsNameTableData>
      <DetailsValueTableData>
        <FlexRow itemsSpacing={22} align={'center'}>
          <TokenWrapper>
            <FlexRow itemsSpacing={4}>
              <BodyText size={3} variation={'darkGray'}>
                <Trans t={t}>Weight:</Trans>
              </BodyText>
              <BodyText size={2} variation={'black'}>
                {data.weight}{' '}
              </BodyText>
            </FlexRow>
          </TokenWrapper>

          <TableDataAccountInfo
            loading={loading}
            logo={logo}
            name={name}
            publicKey={publicKey || hashWithoutPrefix}
            csprName={csprName}
            avatarSize={'default'}
            hashLength={HashLength.FULL}
          />
        </FlexRow>
      </DetailsValueTableData>
    </DetailsTableRow>
  );
};
